export const forgotPassword = {
  'forgot-password.title': 'Forgot your password?',
  'forgot-password.subtitle':
    'Enter your email address below, and we’ll send you an email with a link to reset your password.',
  'forgot-password.success':
    'Reset email sent! Check your inbox to reset your account’s password.',
  'forgot-password.link-text': 'Already set up a new password?',

  // ─── Forgot Password Errors ──────────────────────────────────────────

  'forgot-password.error': `Something went wrong, try again in a few moments...`,
};
